import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RevertCancelStatusModal = ({ show, onClose, onRevertCancelStatus, revertingCancelStatus, hasReturnLabels }) => {
  const { t } = useTranslation()

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={t('Revertir estado cancelado')}
      size="l"
      actions={
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            defaultLabel={t('Aceptar')}
            fullWidth
            onClick={() => onRevertCancelStatus()}
            loading={revertingCancelStatus}
            disabled={revertingCancelStatus}
          />
        </Styles.ActionsContainer>
      }
    >
      <Styles.Container>
        <Text type="bodyMRegular">
          {t('Al revertir el estado cancelado, la transacción volverá a marcarse como "En proceso".')}
        </Text>
        {hasReturnLabels && (
          <Alert type="warning">
            {t(
              'Si el cliente aún no ha devuelto los productos, es posible que sea necesario generar una nueva etiqueta de devolución.'
            )}
          </Alert>
        )}
      </Styles.Container>
    </Modal>
  )
}

export default RevertCancelStatusModal
